import { render, staticRenderFns } from "./ProductLevelIcon.vue?vue&type=template&id=659411d2&"
import script from "./ProductLevelIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProductLevelIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports